// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"cc4951e8","453":"50d81cef"}[chunkId] + ".chunk.js";
};